import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import PressKitItem from './press-kit-item';

const PressKitBlock = ({ items }) => {
  const renderedItems = _.map(items, (item, nav) => {
    const isEven = nav === 0 || nav % 2 === 0;

    return <PressKitItem {...item} evenRow={isEven} key={`item-${nav}`} />;
  });

  const PressKitSection = (
    <div
      className={classNames([
        'press-kit__block--item',
        classes('text-align-center'),
        classes('margin-horizontal-auto'),
      ])}
    >
      {renderedItems}
    </div>
  );

  return (
    <div className={classNames(['press-kit__block'])}>{PressKitSection}</div>
  );
};

PressKitBlock.displayName = 'PressKitBlock';

PressKitBlock.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(PressKitBlock.propTypes)),
  className: PropTypes.string,
  nav: PropTypes.string,
};

export default PressKitBlock;
